import { Grid, Paper } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import BotonNuevoComponent from '../entidades/components/BotonNuevo';
import { checkModuleAccess } from '../modulos/modules.helpers';
import { getAllBancosAction, setActivoBancosAction } from './BancosAction';
import FormBancos from './components/FormBancos';
import ListadoBancos from './components/ListadoBancos';

const BancosView = () => {
  const dispatch = Redux.useDispatch();
  const bancosStore = Redux.useSelector((state) => state.bancos);
  const loginStore = Redux.useSelector((state) => state.login);

  const accessName = 'banks';
  if (!checkModuleAccess(accessName, loginStore)) {
    window.location.href = '/dashboard';
  }

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonNuevoComponent
          click={async () => {
            await setActivoBancosAction(dispatch, null);
          }}
          azul
          mr={2}
        />
        {bancosStore.all.length > 0 && (
          <BotonNuevoComponent
            click={async () => {
              await setActivoBancosAction(dispatch, null);
              await getAllBancosAction(dispatch, bancosStore.params);
            }}
            white
            disabled={bancosStore.loadingGetAll}
            text={bancosStore.loadingGetAll ? 'Actualizando...' : 'Actualizar'}
          />
        )}
      </Grid>
      <Grid item md={4}>
        <Paper elevation={4}>
          <FormBancos />
        </Paper>
      </Grid>
      <Grid item md={8}>
        <ListadoBancos />
      </Grid>
    </Grid>
  );
};

export default BancosView;

export const mesesArray = [
  { nombre: 'Enero', valor: '01' },
  { nombre: 'Febrero', valor: '02' },
  { nombre: 'Marzo', valor: '03' },
  { nombre: 'Abril', valor: '04' },
  { nombre: 'Mayo', valor: '05' },
  { nombre: 'Junio', valor: '06' },
  { nombre: 'Julio', valor: '07' },
  { nombre: 'Agosto', valor: '08' },
  { nombre: 'Septiembre', valor: '09' },
  { nombre: 'Octubre', valor: '10' },
  { nombre: 'Noviembre', valor: '11' },
  { nombre: 'Diciembre', valor: '12' },
];
